import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class EscalationService {

	constructor(private ws: PostmethodService) { }

	createEscalation(request: any) {
		return this.ws.wsPost(request, environment.loginUrl + "/head-office/escalation");
	}

	getEscalation() {
		return this.ws.wsGet(environment.loginUrl + "/head-office/escalation");
	}
	updateEscalation(request: any, id: any) {
		return this.ws.wsPatch(request, environment.loginUrl + "/head-office/escalation", id);
	}

	createEscalationHours(request: any, outlet_id: any) {
		return this.ws.wsPatch(request, environment.loginUrl + "/head-office/outlet", outlet_id);
	}

	getEscalationHours(outlet_id: any) {
		return this.ws.wsGet(environment.loginUrl + "/head-office/outlet/"+outlet_id);
	}

}